import { parsePID } from "../../utils";

const CommonService = {
  getOTP: async (text) => {
    const safePID = parsePID(text);
    const POST_URL = `/api/v1/users/forget/${safePID}/otp`;
    try {
      const response = await fetch(`${POST_URL}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(),
        credentials: "include",
      });
      return await response.json();
    } catch (err) {
      return null;
    }
  },

  verifyOTP: async (patientId, newToken, otp) => {
    const safePID = parsePID(patientId);
    const POST_URL = `/api/v1/users/forget/${safePID}/otp/verify`;
    try {
      const postData = {
        tid: newToken,
        otp: otp,
      };
      // console.log(postData);
      const response = await fetch(`${POST_URL}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(postData),
        credentials: "include",
      });
      return await response.json();
    } catch (err) {
      console.log(err);
      return null;
    }
  },
};

export default CommonService;
